import React from "react";
import { styled } from "styled-components";

import {
  EditIcon,
  UserIcon,
  WorkspaceIcon,
} from "../../components/icons/CustomIcons";
import { Flex, HexAnchorButton, Txt } from "../../hex-components";
import { useMeQuery } from "../../route/HexRoutes.generated";
import { Routes } from "../../route/routes";

import { getCurrentUrl } from "./util";

export const CliAuthWorkspaceSelect = React.memo(
  function CliAuthWorkspaceSelect() {
    const { data: meData } = useMeQuery();

    if (!meData?.myOrg) return null;
    return (
      <Flex align="stretch" direction="row" gap={8}>
        <TagFlex>
          <UserIcon />
          <Txt>{meData.me?.email}</Txt>
        </TagFlex>
        <TagFlex>
          <WorkspaceIcon />
          <Txt>{meData.myOrg.displayName}</Txt>
          <HexAnchorButton
            css="margin-left: auto;"
            extraSmall={true}
            href={Routes.ORG_SELECTOR.getUrl({
              queryParams: { redirectTo: getCurrentUrl() },
            })}
            icon={<EditIcon />}
            subtle={true}
          />
        </TagFlex>
      </Flex>
    );
  },
);

const TagFlex = styled(Flex).attrs({
  align: "center",
  gap: 8,
})`
  flex: 1;
  font-size: ${({ theme }) => theme.fontSize.SMALL};
  padding: 8px 8px 8px 12px;
  border-radius: ${({ theme }) => theme.borderRadius};
  border: 1px solid ${({ theme }) => theme.borderColor.MUTED};
`;
